// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"949":"cc83dcc2","970":"ce290532","994":"f103c5b9"}[chunkId] + ".css";
};